export default __webpack_public_path__ + "static/media/category-category.fbff196d.png";